import React from 'react';

class Input extends React.Component {
    constructor(props) {
        super(props);

        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(event) {
        if (this.props.onChange) {
            this.props.onChange(this.props.name, event.currentTarget.value);
        }
    }

    render() {
        const _props = {};
        for (let id in this.props) {
            switch (id) {
                case 'children':
                case 'config':
                case 'textArea':
                case 'wrap':
                case 'onChange':
                case 'onRef':
                    continue;
                case 'disabled':
                    if (this.props[id] == true) {
                        _props[id] = true;
                    }
                    break;
                case 'value':
                    _props[id] = this.props[id] || '';
                    break;
                default:
                    _props[id] = this.props[id];
                    break;
            }
        }
        const content = (
            <React.Fragment>
                {
                    this.props.textArea &&
                    <textarea {..._props} ref={this.props.onRef} onChange={this.handleChange}></textarea>
                }
                {
                    !this.props.textArea &&
                    <input {..._props} ref={this.props.onRef} onChange={this.handleChange} />
                }
                {this.props.children}
            </React.Fragment>
        );
        if (this.props.wrap == false) {
            return content;
        }
        let className = 'input__container';
        if (this.props.config) {
            for (let id in this.props.config) {
                const value = this.props.config[id];
                if (!value) {
                    return;
                }
                className += ` input--${value}`;
            }
        }
        if (this.props.textArea) {
            className += ' input--area';
        }
        return (
            <div className={className}>
                {content}
            </div>
        );
    }
}

function Onboarding(props) {
    const [value, setValue] = React.useState(props.value || '');
    React.useEffect(() => {
      if (props.value != undefined) {
        setValue(props.value);
      }
    }, [props.value]);
    const handleChange = (e) => {
      if (!e.target || !props.onChange) {
        return;
      }
      let _value = e.target.value;
      setValue(_value);
      props.onChange(props.name, _value);
    }
    return <input {...props} value={value} onChange={handleChange} />
  }

export { Input, Onboarding };